import React, { useState } from 'react';
import {
  Grid, Typography, Card, Divider,
} from '@mui/material';
import KingBedIcon from '@mui/icons-material/KingBed';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import WheelchairPickupIcon from '@mui/icons-material/WheelchairPickup';
import { useSelector } from 'react-redux';
import ExportImage from 'common/components/exportImage';
import { specificBenefitChecked } from 'common/Constants';
import { CARRIER_CODE } from 'common/AppConstant';
import PolicyCard from './common/policyCard';
import HospitalIndemnityDialog from './policyModelTable/hospitalIndemnityDialog';
import CriticalIllnessDialog from './policyModelTable/criticalIllnessDialog';
import AccidentDialog from './policyModelTable/accidentDialog';

function ProductSummary({
  HIFlag, CIFlag, ACFlag, productSummaryRef,
}) {
  const hospitalIndemnityObject = useSelector(
    (state) => state.scenario.hospitalIndemnityObject,
  );
  const totalPayout = useSelector(
    (state) => state.scenario.totalPayout,
  );
  const totalCount = useSelector(
    (state) => state.scenario.totalCount,
  );
  const criticalIllnessObject = useSelector(
    (state) => state.scenario.criticalIllnessObject,
  );
  const accidentObject = useSelector(
    (state) => state.scenario.accidentObject,
  );
  const HIPayoutDetail = useSelector(
    (state) => state.scenario.HIPayoutDetail,
  );
  const CIPayoutDetail = useSelector(
    (state) => state.scenario.CIPayoutDetail,
  );
  const ACPayoutDetail = useSelector(
    (state) => state.scenario.ACPayoutDetail,
  );
  const HIProductIncluded = useSelector((state) => state.scenario.includeProductHI);
  const CIProductIncluded = useSelector((state) => state.scenario.includeProductCI);
  const ACProductIncluded = useSelector((state) => state.scenario.includeProductAC);

  const [HIDialogOpen, setHIDialogOpen] = useState(false);
  const [CIDialogOpen, setCIDialogOpen] = useState(false);
  const [ACDialogOpen, setACDialogOpen] = useState(false);

  const carrierCode = localStorage.getItem(CARRIER_CODE);
  const wellnessHIBenefit = HIPayoutDetail?.find((benefit) => benefit?.code === 'wellness2');
  const wellnessCIBenefit = CIPayoutDetail?.find((benefit) => benefit?.code === 'wellness2');
  const wellnessACBenefit = ACPayoutDetail?.find((benefit) => benefit?.code === 'wellness2');
  const wellnessCheckedForHI = hospitalIndemnityObject[specificBenefitChecked[carrierCode]?.HI];
  const wellnessCheckedForCI = criticalIllnessObject[specificBenefitChecked[carrierCode]?.CI];
  const wellnessCheckedForAC = accidentObject[specificBenefitChecked[carrierCode]?.AC];

  return (
    <>
      <Grid item xs={12}>
        <Card ref={productSummaryRef}>
          <Grid container spacing={2}>
            <Grid item xs={12} container variant="addPaddingBottom" justifyContent="space-between">
              <Typography variant="h5">
                Product Summary
              </Typography>
              <ExportImage sectionRef={productSummaryRef} sectionName="product_summary" />
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid container spacing={2} item xs={12} justifyContent="center">
              {HIFlag && HIProductIncluded ? (
                <Grid item xs={4}>
                  <PolicyCard
                    hasCheck={false}
                    policies={1}
                    benefits={7}
                    payout={totalPayout.HI.payout.TOTAL}
                    people={totalCount.HI.count.TOTAL}
                    displayName="Hospital Indemnity"
                    backgroundIcon={(
                      <KingBedIcon
                        sx={{ fontSize: '100px' }}
                      />
                  )}
                    specificBenefit={wellnessHIBenefit}
                    specificBenefitChecked={wellnessCheckedForHI}
                    handleDialogOpen={() => setHIDialogOpen(true)}
                  />
                </Grid>
              ) : null}
              {CIFlag && CIProductIncluded ? (
                <Grid item xs={4}>
                  <PolicyCard
                    hasCheck={false}
                    policies={5}
                    benefits={31}
                    payout={totalPayout.CI.payout.TOTAL}
                    people={totalCount.CI.count.TOTAL}
                    displayName="Critical Illness"
                    backgroundIcon={<LocalHospitalIcon sx={{ fontSize: '100px' }} />}
                    specificBenefit={wellnessCIBenefit}
                    specificBenefitChecked={wellnessCheckedForCI}
                    handleDialogOpen={() => setCIDialogOpen(true)}
                  />
                </Grid>
              ) : null}
              {ACFlag && ACProductIncluded ? (
                <Grid item xs={4}>
                  <PolicyCard
                    hasCheck={false}
                    policies={4}
                    benefits={40}
                    payout={totalPayout.AC.payout.TOTAL}
                    people={totalCount.AC.count.TOTAL}
                    displayName="Accident"
                    backgroundIcon={<WheelchairPickupIcon sx={{ fontSize: '100px' }} />}
                    specificBenefit={wellnessACBenefit}
                    specificBenefitChecked={wellnessCheckedForAC}
                    handleDialogOpen={() => setACDialogOpen(true)}
                  />
                </Grid>
              ) : null }
              {(!HIFlag && !CIFlag && !ACFlag)
              || (!ACProductIncluded && !CIProductIncluded && !HIProductIncluded) ? (
                <Grid item xs={12} container justifyContent="center" alignItems="center">
                  <Typography variant="body1">No product(s) to display</Typography>
                </Grid>
                ) : null}
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <HospitalIndemnityDialog
        open={HIDialogOpen}
        handleClose={() => setHIDialogOpen(false)}
        title="Hospital Indemnity"
        isReadOnly
      />
      <CriticalIllnessDialog
        open={CIDialogOpen}
        handleClose={() => setCIDialogOpen(false)}
        title="Critical Illness"
        isReadOnly
      />
      <AccidentDialog
        open={ACDialogOpen}
        handleClose={() => setACDialogOpen(false)}
        title="Accident"
        isReadOnly
      />
    </>
  );
}

export default ProductSummary;
